import GenericAjaxService from './GenericAjaxService';
import {publicAPI} from './api';

export default class NotificationService extends GenericAjaxService {

    static getNotifications(opts) {

        return super.getAPI(publicAPI, `notifications`, opts);
    }
}